
import { ContactForm } from "@/components/ContactForm";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

export const ResourcesSection = () => {
  const { t } = useTranslation();
  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="border border-white/10 bg-white/5 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-[#c9a84c]">{t('plans_detail.safety_net.resources.doc_title')}</h3>
          <p className="text-sm text-white/50 mb-3">
            {t('plans_detail.safety_net.resources.source_label')}<a
              href="https://www.fsa.go.jp/news/r6/ginkou/20241128/yousei.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#c9a84c] hover:underline"
            >
              {t('plans_detail.safety_net.resources.fsa_name')}
            </a>
          </p>

          <div className="text-sm space-y-3 overflow-y-auto max-h-96 pr-2 text-white/65 leading-relaxed">
            <p>
              {t('plans_detail.safety_net.resources.p1')}
            </p>
            <p>
              {t('plans_detail.safety_net.resources.p2')}
            </p>
            <p>
              {t('plans_detail.safety_net.resources.p3')}
            </p>

            <div className="font-bold mt-4 text-white">{t('plans_detail.safety_net.resources.record_label')}</div>

            <div>
              <h4 className="font-bold mt-2 text-white">{t('plans_detail.safety_net.resources.s1_title')}</h4>
              <p>
                {t('plans_detail.safety_net.resources.s1_p1')}
              </p>
              <p>
                {t('plans_detail.safety_net.resources.s1_p2')}
              </p>
              <p>
                {t('plans_detail.safety_net.resources.s1_p3')}
              </p>
            </div>

            <div>
              <h4 className="font-bold mt-2 text-white">{t('plans_detail.safety_net.resources.s2_title')}</h4>
              <p>
                {t('plans_detail.safety_net.resources.s2_p1')}
              </p>
              <p style={{ whiteSpace: 'pre-line' }}>
                {t('plans_detail.safety_net.resources.s2_p2')}
              </p>
            </div>

            <p className="italic text-white/40 mt-2">
              {t('plans_detail.safety_net.resources.full_text_note')}<a
                href="https://www.fsa.go.jp/news/r6/ginkou/20241128/yousei.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline"
              >{t('plans_detail.safety_net.resources.fsa_website')}</a>{t('plans_detail.safety_net.resources.full_text_suffix')}
            </p>
          </div>
        </div>
      </motion.section>
    </>
  );
};
